export default "__VITE_ASSET__29ec8069__"